export default __webpack_public_path__ + "static/media/sysco-logo-header.62bb78bb.png";